<template lang="pug">
  #Sa.h-100
    router-view
</template>

<script>
import { mapState } from 'vuex';
import store from '../../store';
import swal from 'sweetalert2';

export default {
  // 不管這邊打大小寫 顯示都會是以大寫形式為主
  name: 'SmComponent',
  beforeRouteEnter(to, from, next) {
    store.dispatch('sm/getSmProfileHandler')
      .then((res) => {
        if (res.data.personnel.line_position === 'sm') {
          if (res.data.personnel.in_service_status === 'resign' ) {
            store.commit('toggleLoading', false);
            swal.fire({
              title: '身份不符，未綁定CA',
              icon: 'info',
            }).then(() => {
              window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
            });
          } else {
            next();
          }
        } else {
          window.location = process.env.VUE_APP_LINE_ADD_FRIEND_LINK;
        }
      });
  },
  computed: {
    ...mapState({
      smData: (state) => state.sm.smData
    })
  }
};
</script>
